// components/cnt-poezd/component
/* global DEBUG */

import template  from './component.jade'
import Store     from 'Store'
import parseTime from 'lib/filters/parseUnixTime'
import style from './style.scss'

var name = 'train-in-way-info'

const store = new Store(name);

export default {

    name: name,
    template: template({
        style: style
    }),
    props: [],
    mixins: [parseTime],

    data: () => ({
        name: name,
    }),

    events:{
        // при вызове заявки из таблицы контейнеров cnt_poezd
        ['number:' + name]: function (data) {
            this.$set('data', null)
            this.$set('data', data)
        },
    }

}



/** WEBPACK FOOTER **
 ** ./src/js/components/train-in-way-info/component.js
 **/